import {gql} from '@apollo/client';
import {useMemo} from 'react';

import {QueryResultType, useSkippableBenchlingQuery} from 'graphql-client/BenchlingQuery';

import {AllowedEventTrigger} from './RoutineTypes';

const ALLOWED_EVENT_TRIGGERS_QUERY = gql`
  query AllowedEventTriggersQuery @engComponent(name: LLM) @skipAudit {
    allowedEventTriggers {
      objectType
      fields {
        field
        displayName
        allowedValues
      }
    }
  }
`;

interface AllowedEventTriggersQueryData {
  allowedEventTriggers: Array<{
    objectType: string;
    fields: Array<{
      field: string;
      displayName: string;
      allowedValues: Array<string>;
    }>;
  }>;
}

interface UseAllowedEventTriggersResult {
  triggers: Array<AllowedEventTrigger>;
  isLoading: boolean;
  isError: boolean;
}

export default function useAllowedEventTriggers({
  enabled = true,
}: {enabled?: boolean} = {}): UseAllowedEventTriggersResult {
  const queryResult = useSkippableBenchlingQuery<AllowedEventTriggersQueryData>(
    ALLOWED_EVENT_TRIGGERS_QUERY,
    {
      skip: !enabled,
    }
  );

  const queryData =
    queryResult.type === QueryResultType.SUCCESS ? queryResult.data.allowedEventTriggers : null;

  const triggers: Array<AllowedEventTrigger> = useMemo(() => queryData ?? [], [queryData]);

  const isLoading = !enabled ? false : queryResult.type === QueryResultType.PENDING;
  const isError = queryResult.type === QueryResultType.ERROR;

  return {triggers, isLoading, isError};
}
